var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "30px",
    height: "33px",
    viewBox: "0 0 30 33",
    enableBackground: "new 0 0 30 33",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fill: "#FFFFFF",
    d: "M14.94,33c-1.796,0.003-3.523-0.692-4.817-1.939c-0.426-0.416-0.435-1.098-0.019-1.523 c0.006-0.007,0.012-0.014,0.019-0.02H2.394c-1.037,0.018-1.965-0.64-2.294-1.623c-0.292-0.953,0.126-1.979,1-2.457 c0.3-0.266,2.926-2.822,2.926-10.87c0.071-2.775,1.138-5.433,3.006-7.487c1.022-1.165,2.275-2.105,3.68-2.762 c-0.007-0.066-0.007-0.133,0-0.2C10.77,1.792,12.699-0.051,15.027,0c2.327-0.051,4.257,1.79,4.316,4.117 c0.006,0.066,0.006,0.133,0,0.2c1.403,0.657,2.656,1.598,3.679,2.762c1.871,2.053,2.941,4.71,3.014,7.487 c0,8.061,2.634,10.625,2.934,10.892c0.853,0.506,1.235,1.539,0.918,2.478c-0.328,0.988-1.26,1.646-2.3,1.627h-7.83 c0.405,0.418,0.405,1.082,0,1.5C18.464,32.309,16.736,33.004,14.94,33z M11.858,29.534c0.832,0.794,1.938,1.235,3.088,1.235H15 c1.141-0.006,2.234-0.448,3.059-1.235H11.858z M4.679,24.3c-0.457,1.169-1.208,2.2-2.179,2.995h25.111 c-0.973-0.795-1.724-1.826-2.182-2.995H4.679z M15.051,5.585c-4.94,0-8.631,4.743-8.631,8.984c0.044,2.527-0.266,5.046-0.92,7.486 h19.1c-0.652-2.44-0.961-4.96-0.918-7.486C23.682,10.328,19.99,5.585,15.051,5.585z M15.051,3.338c0.617,0,1.231,0.061,1.836,0.18 c-0.318-0.744-1.027-1.247-1.836-1.3c-0.808,0.053-1.518,0.556-1.836,1.3C13.82,3.398,14.435,3.338,15.051,3.338z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellWhite);
export default __webpack_public_path__ + "static/media/bell-white.ea585147f2b803782233208ec099a3d5.svg";
export { ForwardRef as ReactComponent };